module.exports = __webpack_public_path__ + "img/desk1.63d2c9cc.png";